import React, { useState } from 'react';
import styled from 'styled-components';
import { ProgressBar } from 'antd-mobile';
import { PlayOutline, ClockCircleOutline, TeamOutline, MessageOutline } from 'antd-mobile-icons';
import { useParams, useNavigate } from 'react-router-dom';
import TextLightScroll from '../../components/texts/TextLightScroll';

const InteractiveLearningDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  // 模拟数据
  const course = {
    id: 1,
    title: 'AI产品经理训练营',
    description: '深入学习AI产品设计与管理，掌握前沿技术在产品中的应用，成为具备AI思维的产品经理。',
    thumbnail: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&h=400&fit=crop',
    instructor: {
      name: '张明',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop',
      title: '资深AI产品专家',
      experience: '10年产品经验，曾任职于腾讯、字节跳动'
    },
    startDate: '2024-02-01',
    endDate: '2024-04-30',
    duration: '12周',
    participants: 156,
    maxParticipants: 200,
    progress: 35,
    tags: ['AI产品', '产品管理', '实战项目'],
    features: [
      '真实项目实战',
      '1对1导师指导',
      '行业专家分享',
      '求职推荐服务'
    ],
    schedule: [
      {
        week: 1,
        title: 'AI基础与产品思维',
        status: 'completed',
        topics: ['AI技术概览', '产品思维转换', '市场分析方法']
      },
      {
        week: 2,
        title: '用户研究与需求分析',
        status: 'completed',
        topics: ['用户画像构建', '需求挖掘技巧', '竞品分析']
      },
      {
        week: 3,
        title: '产品设计与原型',
        status: 'pending',
        topics: ['交互设计', '原型制作', '用户体验优化']
      }
    ],
    projects: [
      {
        title: '智能推荐系统设计',
        description: '设计一个基于用户行为的智能推荐系统',
        status: 'completed',
        score: 92
      },
      {
        title: 'AI客服产品规划',
        description: '从0到1设计AI客服产品的完整方案',
        status: 'in_progress',
        score: null
      }
    ],
    participants_ranking: [
      { rank: 1, name: '李小明', progress: 95, points: 2850 },
      { rank: 2, name: '王小红', progress: 88, points: 2640 },
      { rank: 3, name: '张小强', progress: 82, points: 2460 }
    ],
    discussions: [
      {
        id: 1,
        user: '李小明',
        avatar: '/api/placeholder/40/40',
        time: '2小时前',
        content: '关于AI产品的数据指标设计，大家有什么好的建议吗？',
        replies: 12
      },
      {
        id: 2,
        user: '王小红',
        avatar: '/api/placeholder/40/40',
        time: '5小时前',
        content: '今天的直播课程很精彩，老师讲的用户画像构建方法很实用！',
        replies: 8
      }
    ]
  };

  const tabs = [
    { key: 'overview', title: '课程概览' },
    { key: 'schedule', title: '学习计划' },
    { key: 'projects', title: '实战项目' },
    { key: 'participants', title: '学员排行' },
    { key: 'discussions', title: '讨论区' }
  ];

  if (!course) {
    return (
      <StyledWrapper>
        <div className="interactive-detail-container">
          <div className="error-container">
            <h2>课程不存在</h2>
            <button className="back-btn" onClick={() => navigate('/learn/interactive')}>返回互动学习</button>
          </div>
        </div>
      </StyledWrapper>
    );
  }

  return (
    <StyledWrapper>
      <div className="interactive-detail-container">
        <div className="breadcrumb">
          <span onClick={() => navigate('/learn/interactive')}>互动学习</span> / {course.title}
        </div>

        <div className="course-header">
          <div className="course-info">
            <TextLightScroll text={course.title} />
            <p className="description">{course.description}</p>
            
            <div className="course-meta">
              <div className="meta-item">
                <ClockCircleOutline />
                <span>{course.duration}</span>
              </div>
              <div className="meta-item">
                <TeamOutline />
                <span>{course.participants}/{course.maxParticipants}人参与</span>
              </div>
              <div className="meta-item">
                <PlayOutline />
                <span>进度 {course.progress}%</span>
              </div>
            </div>

            <div className="course-tags">
              {course.tags.map((tag, index) => (
                <span key={index} className="tag">{tag}</span>
              ))}
            </div>

            <div className="features-list">
              {course.features.map((feature, index) => (
                <span key={index} className="feature-tag">{feature}</span>
              ))}
            </div>
          </div>

          <div className="course-thumbnail">
            <img src={course.thumbnail} alt={course.title} />
          </div>
        </div>

        {/* 参与/进度卡片 */}
        <div className="participation-card">
          <div className="participation-info">
            <div className="dates-section">
              <div className="date-item">
                <span className="label">开始时间</span>
                <span className="value">{course.startDate}</span>
              </div>
              <div className="date-item">
                <span className="label">结束时间</span>
                <span className="value">{course.endDate}</span>
              </div>
            </div>
            
            <div className="progress-section">
              <div className="progress-info">
                <span>学习进度</span>
                <span>{course.progress}%</span>
              </div>
              <ProgressBar percent={course.progress} style={{ '--fill-color': '#4CAF50' }} />
            </div>
          </div>
          
          <button className="participate-btn">
            {course.progress > 0 ? '继续学习' : '立即参与'}
          </button>
        </div>

        {/* 标签页内容 */}
        <div className="tabs-container">
          <div className="tabs-header">
            {tabs.map(tab => (
              <button 
                key={tab.key}
                className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.title}
              </button>
            ))}
          </div>
          <div className="tab-content">
            {activeTab === 'overview' && (
              <div className="overview-content">
                <div className="section">
                  <h3>训练营特色</h3>
                  <div className="features-grid">
                    {course.features.map((feature, index) => (
                      <div key={index} className="feature-item">
                        <div className="feature-icon">✓</div>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="section">
                  <h3>学习收获</h3>
                  <ul>
                    <li>掌握AI产品设计的核心方法论</li>
                    <li>具备AI技术在产品中的应用能力</li>
                    <li>获得真实项目实战经验</li>
                    <li>建立AI产品思维体系</li>
                  </ul>
                </div>
              </div>
            )}

            {activeTab === 'schedule' && (
              <div className="schedule-content">
                {course.schedule.map((week, index) => (
                  <div key={index} className="week-card">
                    <div className="week-header">
                      <h4>第{week.week}周：{week.title}</h4>
                      <span className={`status ${week.status}`}>
                        {week.status === 'completed' ? '已完成' : '待学习'}
                      </span>
                    </div>
                    <div className="topics-list">
                      {week.topics.map((topic, topicIndex) => (
                        <div key={topicIndex} className="topic-item">
                          <span className="topic-bullet">•</span>
                          <span>{topic}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeTab === 'projects' && (
              <div className="projects-content">
                {course.projects.map((project, index) => (
                  <div key={index} className="project-card">
                    <div className="project-header">
                      <h4>{project.title}</h4>
                      <div className="project-status">
                        <span className={`status-badge ${project.status}`}>
                          {project.status === 'completed' ? '已完成' : '进行中'}
                        </span>
                        {project.score && <span className="score">{project.score}分</span>}
                      </div>
                    </div>
                    <p className="project-description">{project.description}</p>
                    <div className="project-actions">
                      <button className="action-btn primary">
                        {project.status === 'completed' ? '查看详情' : '继续完成'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeTab === 'participants' && (
              <div className="participants-content">
                <div className="ranking-header">
                  <h3>学员排行榜</h3>
                  <p>根据学习进度和项目得分综合排名</p>
                </div>
                <div className="participants-list">
                  {course.participants_ranking.map((participant, index) => (
                    <div key={index} className="participant-item">
                      <div className="participant-info">
                        <div className="rank-badge">{participant.rank}</div>
                        <img src={`/api/placeholder/40/40`} alt={participant.name} className="avatar" />
                        <div className="participant-details">
                          <div className="name">{participant.name}</div>
                          <div className="progress">进度: {participant.progress}%</div>
                        </div>
                      </div>
                      <div className="points">{participant.points}分</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'discussions' && (
              <div className="discussions-content">
                <div className="discussion-header">
                  <h3>讨论区</h3>
                  <button className="new-discussion-btn">发起讨论</button>
                </div>
                <div className="discussions-list">
                  {course.discussions.map((discussion, index) => (
                    <div key={index} className="discussion-item">
                      <div className="discussion-header-info">
                        <img src={discussion.avatar} alt={discussion.user} className="avatar" />
                        <div className="discussion-meta">
                          <div className="user-name">{discussion.user}</div>
                          <div className="time">{discussion.time}</div>
                        </div>
                      </div>
                      <p className="discussion-content">{discussion.content}</p>
                      <div className="discussion-actions">
                        <span className="replies">
                          <MessageOutline /> {discussion.replies}条回复
                        </span>
                        <button className="reply-btn">回复</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .interactive-detail-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background: #f5f5f5;
    min-height: 100vh;
    color: #333;
  }

  .error-container {
    text-align: center;
    padding: 100px 20px;
    
    h2 {
      margin-bottom: 20px;
      color: #333;
    }
  }

  .back-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    
    &:hover {
      background: #0056b3;
    }
  }

  .course-header {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 40px;
    margin-bottom: 30px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  .breadcrumb {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 10px;
    
    span:first-child {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .course-info {
    h1 {
      font-size: 2.2rem;
      font-weight: bold;
      margin: 0 0 15px 0;
      color: #333;
      line-height: 1.3;
    }
    
    .description {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #666;
      margin-bottom: 20px;
    }
  }

  .course-meta {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    
    .meta-item {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 0.95rem;
      color: #666;
    }
  }

  .course-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 15px;
    
    .tag {
      background: #e3f2fd;
      color: #1976d2;
      padding: 4px 12px;
      border-radius: 16px;
      font-size: 0.8rem;
      border: 1px solid #bbdefb;
    }
  }

  .features-list {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    
    .feature-tag {
      background: #e8f5e8;
      color: #4CAF50;
      padding: 6px 12px;
      border-radius: 16px;
      font-size: 0.8rem;
      border: 1px solid #c8e6c9;
    }
  }

  .course-thumbnail {
    border-radius: 12px;
    overflow: hidden;
    height: fit-content;
    
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .participation-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }

  .participation-info {
    margin-bottom: 20px;
  }

  .dates-section {
    display: flex;
    gap: 30px;
    margin-bottom: 20px;
    
    .date-item {
      display: flex;
      flex-direction: column;
      gap: 5px;
      
      .label {
        font-size: 0.9rem;
        color: #666;
      }
      
      .value {
        font-size: 1.1rem;
        font-weight: 600;
        color: #007bff;
      }
    }
  }

  .progress-section {
    .progress-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      font-size: 0.9rem;
    }
  }

  .participate-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    
    &:hover {
      background: #0056b3;
    }
  }

  .tabs-container {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }

  .tabs-header {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    
    .tab-button {
      flex: 1;
      padding: 16px;
      border: none;
      background: #f8f9fa;
      color: #666;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.2s;
      
      &:hover {
        background: #e9ecef;
      }
      
      &.active {
        background: white;
        color: #007bff;
        border-bottom: 2px solid #007bff;
      }
    }
  }

  .tab-content {
    padding: 24px;
  }

  .overview-content {
    .section {
      margin-bottom: 30px;
      
      h3 {
        font-size: 1.3rem;
        margin-bottom: 15px;
        color: #333;
      }
    }
    
    .features-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 15px;
      
      .feature-item {
        display: flex;
        align-items: center;
        gap: 10px;
        
        .feature-icon {
          background: #4CAF50;
          color: white;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
        }
      }
    }
    
    ul {
      list-style: none;
      padding: 0;
      
      li {
        margin-bottom: 10px;
        padding-left: 20px;
        position: relative;
        
        &:before {
          content: '•';
          color: #4CAF50;
          position: absolute;
          left: 0;
        }
      }
    }
  }

  .schedule-content {
    .week-card {
      background: #f8f9fa;
      border: 1px solid #e0e0e0;
      border-radius: 12px;
      margin-bottom: 20px;
      padding: 20px;
    }
    
    .week-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      h4 {
        margin: 0;
        color: #333;
        font-size: 1.1rem;
      }
      
      .status {
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 0.8rem;
        
        &.completed {
          background: #e8f5e8;
          color: #4CAF50;
        }
        
        &.pending {
          background: #f5f5f5;
          color: #9E9E9E;
        }
      }
    }
    
    .topics-list {
      .topic-item {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
        
        .topic-bullet {
          color: #4CAF50;
        }
      }
    }
  }

  .projects-content {
    .project-card {
      background: #f8f9fa;
      border: 1px solid #e0e0e0;
      border-radius: 12px;
      margin-bottom: 20px;
      padding: 20px;
    }
    
    .project-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      
      h4 {
        margin: 0;
        color: #333;
        font-size: 1.1rem;
      }
      
      .project-status {
        display: flex;
        align-items: center;
        gap: 10px;
        
        .status-badge {
          padding: 4px 8px;
          border-radius: 8px;
          font-size: 0.75rem;
          
          &.completed {
            background: #e8f5e8;
            color: #4CAF50;
          }
          
          &.in_progress {
            background: #fff3e0;
            color: #ff9800;
          }
        }
        
        .score {
          font-size: 0.9rem;
          color: #007bff;
          font-weight: 600;
        }
      }
    }
    
    .project-description {
      margin: 10px 0 15px 0;
      color: #666;
      line-height: 1.4;
    }
    
    .project-actions {
      .action-btn {
        background: #007bff;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
        
        &:hover {
          background: #0056b3;
        }
      }
    }
  }

  .participants-content {
    .ranking-header {
      text-align: center;
      margin-bottom: 20px;
      
      h3 {
        margin: 0 0 5px 0;
        color: #333;
      }
      
      p {
        margin: 0;
        color: #666;
        font-size: 0.9rem;
      }
    }
    
    .participant-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #e0e0e0;
      
      .participant-info {
        display: flex;
        align-items: center;
        gap: 15px;
        
        .rank-badge {
          background: #007bff;
          color: white;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 0.9rem;
        }
        
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        
        .participant-details {
          .name {
            font-weight: 600;
            color: #333;
            margin-bottom: 2px;
          }
          
          .progress {
            font-size: 0.8rem;
            color: #666;
          }
        }
      }
      
      .points {
        font-weight: bold;
        color: #4CAF50;
        font-size: 1.1rem;
      }
    }
  }

  .discussions-content {
    .discussion-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      
      h3 {
        margin: 0;
        color: #333;
      }
      
      .new-discussion-btn {
        background: #007bff;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
        
        &:hover {
          background: #0056b3;
        }
      }
    }
    
    .discussions-list {
      .discussion-item {
        background: #f8f9fa;
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        margin-bottom: 15px;
        padding: 20px;
      }
      
      .discussion-header-info {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        
        .discussion-meta {
          .user-name {
            font-weight: 600;
            color: #333;
            margin-bottom: 2px;
          }
          
          .time {
            font-size: 0.8rem;
            color: #666;
          }
        }
      }
      
      .discussion-content {
        margin: 10px 0 15px 0;
        line-height: 1.5;
        color: #666;
      }
      
      .discussion-actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .replies {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 0.9rem;
          color: #666;
        }
        
        .reply-btn {
          background: #007bff;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
          
          &:hover {
            background: #0056b3;
          }
        }
      }
    }
  }
`;

export default InteractiveLearningDetail;